export const ACCESS_TOKEN_KEY = 'access_token';
export const REFRESH_TOKEN_KEY = 'refresh_token';
export const JOURNALS_KEY = 'journals';
export const JOURNAL_CATEGORIES_KEY = 'journal_categories';
export const ACCESS_TOKEN_TYPE = 'access_token';
export const API_URL_KEY = 'api_url';
export const LOGGED_IN_TENANT_KEY = 'loggedInTenant';
export const APP_URL_KEY = 'app_url';
export const WORKSPACE_DOMAIN_KEY = 'workspace_domain';
export const AUTOPILOTS_BASE_URL = '/autopilot';
export const ENTERPRISE_BASE_URL = '/enterprise';
export const USER_ANALYTICS_TOGGLED_KEY = 'userAnalyticsToggled';
export const QUALITY_PERFORMANCE_TOGGLED_KEY = 'qualityPerformanceToggled';
export const WEB_PUSH_TOGGLED_KEY = 'webPushToggled';
export const CSRF_TOKEN_KEY = 'csrf_token';
export const POSTHOG_KEY = 'posthog';
export const PORTKEY_KEY = 'portkey';
export const WEB_PUSH_KEY = 'webPush';
export const AUTOPILOTS_DRAFT_KEY = 'autopilots_draft';
export const INTERNAL_MEETING_BOT_TOGGLED_KEY =
	'internalMeetingBotDisabledToggled';
export const SEARCH_FILTERS_KEY = 'search_filters';
export const EXAMPLE_FEED_KEY = 'example_feed';
// MightyBot prod domain
export const MIGHTYBOT_PROD = 'app.mightybot.ai';

export const CRON_KEYS = [
	{ id: 'year', label: 'Year' },
	{ id: 'month', label: 'Month' },
	{ id: 'day', label: 'Day' },
	{ id: 'week', label: 'Week' },
	{ id: 'day_of_week', label: 'Day of Week' },
	{ id: 'hour', label: 'Hour' },
	{ id: 'minute', label: 'Minute' },
	{ id: 'second', label: 'Second' },
];

export const INTERVAL_UNITS = [
	{
		id: 'minutes',
		label: 'minutes',
	},
	{
		id: 'hours',
		label: 'hours',
	},
	{
		id: 'days',
		label: 'days',
	},
	{
		id: 'weeks',
		label: 'weeks',
	},
	{
		id: 'months',
		label: 'months',
	},
	{
		id: 'years',
		label: 'years',
	},
];

export const SELECTED_MODEL_KEY = 'selectedModel';
export const MODELS = [
	{ id: 'auto', label: 'Auto' },
	{ id: 'gpt-5-mini', label: 'GPT-5 Mini' },
	{ id: 'gpt-5', label: 'GPT-5' },
	{ id: 'claude-sonnet-4-20250514', label: 'Claude Sonnet 4' },
	{ id: 'gemini-2.5-flash', label: 'Gemini 2.5 Flash' },
	{ id: 'gemini-2.5-pro', label: 'Gemini 2.5 Pro' },
	{ id: 'grok-3-mini', label: 'Grok 3 Mini' },
];

// Paths that must NOT trigger the session-expired redirect-and-toast flow.
// `isPublicPage` (helper.ts) normalizes variants (trailing slash, `?redirect=…`,
// `/app` basename) and matches exact-path OR nested-path (`/snippets/abc-123`
// matches `/snippets`). One canonical list — the previous PUBLIC_PATHS /
// PUBLIC_ROUTES split was an accident of history that hid `/signup` from the
// auth-screen guard and produced the spurious "Session expired" toast.
export const PUBLIC_PATHS = [
	'/signin',
	'/login',
	'/signup',
	'/auth/callback',
	'/oauth/callback',
	'/email/unsubscribe',
	'/email/feedback',
	// Token-authority invite landing: a logged-out invitee must reach the
	// accept screen. Without this, the global 401 handler (api/base.ts) bounces
	// them to /login on the app-boot /api/me 401 and drops the invite token.
	'/accept-invite',
	'/snippets',
	'/billing/dashboard',
	// CLI install docs reachable from the CliInstallPopover's "Learn more"
	// link, which is mounted on /signin and /signup. `isPublicPage` matches by
	// prefix-segment, so this covers every page under /cli/* (cli-install-signin,
	// cli-install, etc.) WITHOUT making the rest of /docs/platform-playbook
	// public. Granular allowlist — add new public sub-paths here.
	'/docs/platform-playbook/cli',
];
